import { render, staticRenderFns } from "./study-list.vue?vue&type=template&id=a966880a&scoped=true&"
import script from "./study-list.vue?vue&type=script&lang=ts&"
export * from "./study-list.vue?vue&type=script&lang=ts&"
import style0 from "./study-list.vue?vue&type=style&index=0&id=a966880a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a966880a",
  null
  
)

export default component.exports